export function Home() {
  return (
    <div className="w-full">
      <header className="sticky top-0 z-40 backdrop-blur supports-[backdrop-filter]:bg-white/60 bg-white/80 border-b border-border">
        <div className="mx-auto max-w-6xl px-6 py-4 flex items-center justify-between">
          <a href="#top" className="group inline-flex items-center gap-2">
            <img
              src="https://storage.stardeck.ai/images/50940266-93d0-4087-9324-6a87b66bd40a.png"
              alt="Duckie Duck logo"
              className="h-8 w-8 object-contain"
            />
            <span
              className="text-xl font-semibold tracking-tight"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              Duckie Duck
            </span>
          </a>
          <nav className="hidden md:flex items-center gap-8 text-sm">
            <a className="hover:text-primary transition-colors" href="#menu">
              Menu
            </a>
            <a className="hover:text-primary transition-colors" href="#about">
              About
            </a>
            <a className="hover:text-primary transition-colors" href="#gallery">
              Gallery
            </a>
            <a className="hover:text-primary transition-colors" href="#visit">
              Visit
            </a>
          </nav>
          <a
            href="#visit"
            className="ml-4 inline-flex items-center rounded-full bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:opacity-95 transition-opacity"
          >
            Reserve
          </a>
        </div>
      </header>

      <section id="top" className="mx-auto max-w-6xl px-6 py-16 md:py-24">
        <div className="rounded-2xl border border-border bg-card overflow-hidden">
          <div className="grid md:grid-cols-2">
            <div className="p-8 md:p-12 flex flex-col justify-center">
              <div className="inline-flex w-fit rounded-full bg-secondary px-3 py-1 text-xs tracking-wide uppercase text-foreground">
                Ploenchit • Bangkok
              </div>
              <h1
                className="mt-4 text-4xl md:text-5xl leading-tight font-semibold text-foreground"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Duckie Duck
              </h1>
              <p className="mt-4 max-w-xl text-base md:text-lg text-foreground/80">
                Handcrafted duck noodle bowls, rich broths, and Bangkok comfort. Two minutes from
                BTS Ploenchit.
              </p>
              <div className="mt-8 flex flex-wrap gap-3">
                <a
                  href="#menu"
                  className="inline-flex items-center rounded-md bg-primary px-5 py-3 text-sm font-medium text-primary-foreground hover:opacity-95 transition-opacity"
                >
                  Explore Menu
                </a>
                <a
                  href="#visit"
                  className="inline-flex items-center rounded-md border border-border bg-white px-5 py-3 text-sm font-medium hover:border-foreground/30"
                >
                  Book a Table
                </a>
              </div>
            </div>
            <div className="relative h-64 md:h-full">
              <img
                src="https://storage.stardeck.ai/images/97ed5c2e-e1cf-429d-bead-56ebfeb4a651.jpg"
                alt="Duckie Duck noodles"
                className="absolute inset-0 h-full w-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      <section id="menu" className="mx-auto max-w-6xl px-6 py-20">
        <div className="grid md:grid-cols-3 gap-6">
          <MenuCard
            title="Signature Duck Noodles"
            price="160 THB"
            desc="Silky egg noodles, roasted duck, aromatic soy-anise broth."
            img="https://images.pexels.com/photos/20844845/pexels-photo-20844845.jpeg"
          />
          <MenuCard
            title="Crispy Duck Rice"
            price="180 THB"
            desc="Crisp-skinned duck, jasmine rice, scallion-ginger sauce."
            img="https://images.pexels.com/photos/5338137/pexels-photo-5338137.jpeg"
          />
          <MenuCard
            title="Spicy Duck Tom Yum"
            price="190 THB"
            desc="Bright, spicy-sour broth with duck, herbs, and lime."
            img="https://images.pexels.com/photos/23645816/pexels-photo-23645816.jpeg"
          />
        </div>
      </section>

      <section id="about" className="mx-auto max-w-6xl px-6 py-16">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <div className="rounded-xl overflow-hidden border border-border">
            <img
              src="https://images.pexels.com/photos/4985538/pexels-photo-4985538.jpeg"
              alt="Noodle broth"
              className="w-full h-80 object-cover"
            />
          </div>
          <div>
            <h2
              className="text-3xl font-semibold"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              Bangkok soul, bowl by bowl
            </h2>
            <p className="mt-4 text-foreground/80">
              We simmer our broths for 12 hours with star anise, cinnamon, and charred aromatics.
              Our ducks are roasted daily for lacquered skin and tender meat. Simple, focused, and
              comforting.
            </p>
            <ul className="mt-6 grid grid-cols-2 gap-3 text-sm">
              <li className="rounded-lg bg-secondary px-4 py-3">House-roasted duck</li>
              <li className="rounded-lg bg-secondary px-4 py-3">12-hour broth</li>
              <li className="rounded-lg bg-secondary px-4 py-3">Fresh daily noodles</li>
              <li className="rounded-lg bg-secondary px-4 py-3">Local herbs & spices</li>
            </ul>
          </div>
        </div>
      </section>

      <section id="gallery" className="bg-secondary/50">
        <div className="mx-auto max-w-6xl px-6 py-16">
          <h2 className="text-3xl font-semibold" style={{ fontFamily: "Playfair Display, serif" }}>
            A peek into Duckie Duck
          </h2>
          <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-4">
            <GalleryImg
              src="https://images.pexels.com/photos/4985534/pexels-photo-4985534.jpeg"
              alt="Guest enjoying noodles"
            />
            <GalleryImg
              src="https://images.pexels.com/photos/6646358/pexels-photo-6646358.jpeg"
              alt="Ramen close-up"
            />
            <GalleryImg
              src="https://images.pexels.com/photos/19975140/pexels-photo-19975140.jpeg"
              alt="Duck noodle ramen"
            />
            <GalleryImg
              src="https://images.pexels.com/photos/18565074/pexels-photo-18565074.jpeg"
              alt="Bowl with toppings"
            />
          </div>
        </div>
      </section>

      <section id="visit" className="mx-auto max-w-6xl px-6 py-16">
        <div className="grid md:grid-cols-2 gap-10">
          <div>
            <h2
              className="text-3xl font-semibold"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              Visit us
            </h2>
            <p className="mt-4 text-foreground/80">
              Ploenchit, Bangkok — 2 minutes from BTS Ploenchit Exit 2.
            </p>
            <div className="mt-6 grid grid-cols-2 gap-6 text-sm">
              <div>
                <div className="font-semibold">Hours</div>
                <p className="mt-2 text-foreground/80">
                  Mon–Fri: 11:30–21:30
                  <br />
                  Sat–Sun: 11:00–22:00
                </p>
              </div>
              <div>
                <div className="font-semibold">Contact</div>
                <p className="mt-2 text-foreground/80">
                  +66 2 123 4567
                  <br />
                  hello@duckieduck.com
                </p>
              </div>
            </div>
            <div className="mt-6 flex gap-3">
              <a
                href="tel:+6621234567"
                className="inline-flex items-center rounded-md bg-primary px-5 py-3 text-sm font-medium text-primary-foreground hover:opacity-95"
              >
                Call
              </a>
              <a
                href="mailto:hello@duckieduck.com"
                className="inline-flex items-center rounded-md border border-border bg-white px-5 py-3 text-sm font-medium hover:border-foreground/30"
              >
                Email
              </a>
            </div>
          </div>
          <a
            className="group rounded-xl overflow-hidden border border-border block"
            href="https://maps.google.com/?q=Ploenchit+Bangkok"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="https://images.pexels.com/photos/21517337/pexels-photo-21517337.jpeg"
              alt="Soup and herbs"
              className="w-full h-80 object-cover transition-transform duration-300 group-hover:scale-[1.02]"
            />
            <div className="p-4 bg-white">Open in Google Maps</div>
          </a>
        </div>
      </section>

      <footer className="border-t border-border">
        <div className="mx-auto max-w-6xl px-6 py-10 text-sm flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-foreground/70">
            © {new Date().getFullYear()} Duckie Duck. All rights reserved.
          </div>
          <div className="flex items-center gap-6">
            <a className="hover:text-primary" href="#menu">
              Menu
            </a>
            <a className="hover:text-primary" href="#visit">
              Visit
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

function MenuCard({
  title,
  price,
  desc,
  img,
}: {
  title: string;
  price: string;
  desc: string;
  img: string;
}) {
  return (
    <div className="rounded-xl overflow-hidden border border-border bg-card">
      <img src={img} alt={title} className="h-48 w-full object-cover" />
      <div className="p-5">
        <div className="flex items-baseline justify-between">
          <h3 className="text-lg font-semibold" style={{ fontFamily: "Playfair Display, serif" }}>
            {title}
          </h3>
          <span className="text-sm rounded-full bg-accent px-3 py-1">{price}</span>
        </div>
        <p className="mt-2 text-sm text-foreground/75">{desc}</p>
      </div>
    </div>
  );
}

function GalleryImg({ src, alt }: { src: string; alt: string }) {
  return (
    <div className="rounded-lg overflow-hidden border border-border bg-card">
      <img src={src} alt={alt} className="aspect-square w-full object-cover" />
    </div>
  );
}
